import useGlobalStore from "../../../store/global.store";
import { useEffect, useRef, useState } from "react";
import { useTV } from "../../../hooks/useTV";
import { useRemote } from "../../../hooks/useRemote";
import VipSubCheck from "./VipSubCheck";

const VipSelectorDoor2 = () => {
  const setShowBottomBar = useGlobalStore((state) => state.setShowBottomBar);
  const setShowVipSelector = useGlobalStore(
    (state) => state.setShowVipSelector
  );
  const setSelectedVipDoor = useGlobalStore(
    (state) => state.setSelectedVipDoor
  );
  const { isTv } = useTV();
  const { updateView } = useRemote();

  const [focusedButton, setFocusedButton] = useState("rooftop");

  const rooftopRef = useRef(null);
  const clubLevelRef = useRef(null);
  const vipCastleRef = useRef(null);
  const vipBoatRef = useRef(null);
  const exitRef = useRef(null);

  const handleRooftopClick = () => {
    console.log("VIP Rooftop Terrace selected");
    updateView("VIP__roof", () => {
      setShowVipSelector(false);
      setSelectedVipDoor(null);
      setShowBottomBar(false);
    });
  };

  const handleHotelSuiteClick = () => {
    console.log("VIP Hotel Suite selected");
    updateView("VIP__hotel", () => {
      setShowVipSelector(false);
      setSelectedVipDoor(null);
      setShowBottomBar(false);
    });
  };

  const handleVipCastleClick = () => {
    console.log("VIP Castle selected");
    updateView("VIP__castle", () => {
      setShowVipSelector(false);
      setSelectedVipDoor(null);
      setShowBottomBar(false);
    });
  };

  const handleVipBoatClick = () => {
    console.log("VIP Boat selected");
    updateView("VIP__boat", () => {
      setShowVipSelector(false);
      setSelectedVipDoor(null);
      setShowBottomBar(false);
    });
  };

  const handleExitClick = () => {
    console.log("Exit clicked, returning to door selection");

    updateView("VIP", () => {});
  };

  const getCardStyle = (buttonId, isExit = false) => {
    const baseStyle = {
      position: "relative",
      cursor: "pointer",
      borderRadius: "15px",
      overflow: "hidden",
      transition: "all 0.3s ease",
      width: isTv ? "500px" : "400px",
      height: isTv ? "300px" : "240px",
      outline: "none",
      border:
        isTv && focusedButton === buttonId
          ? "6px solid #3ADF3C"
          : "6px solid white",
      boxSizing: "border-box",
      boxShadow: !isTv ? "0 4px 20px rgba(0,0,0,0.3)" : "none",
    };

    if (isExit) {
      return {
        ...baseStyle,
        backgroundColor: "#ff0000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      };
    }

    return baseStyle;
  };

  const getLabelStyle = () => ({
    color: "white",
    fontSize: isTv ? "24px" : "18px",
    fontWeight: "bold",
    fontFamily: "Lato",
    textAlign: "center",
    textShadow: "2px 2px 4px rgba(0,0,0,0.8)",
    width: "100%",
  });

  useEffect(() => {
    setShowBottomBar(false);
    if (isTv && rooftopRef.current) {
      rooftopRef.current.focus();
      setFocusedButton("rooftop");
    }
  }, [isTv]);

  useEffect(() => {
    if (isTv) {
      const handleKeyDown = (e) => {
        const gridButtons = [
          ["rooftop", "clubLevel", "vipBoat"],
          ["vipCastle", "exit", null],
        ];

        let currentRow = -1;
        let currentCol = -1;

        for (let row = 0; row < gridButtons.length; row++) {
          for (let col = 0; col < gridButtons[row].length; col++) {
            if (gridButtons[row][col] === focusedButton) {
              currentRow = row;
              currentCol = col;
              break;
            }
          }
          if (currentRow !== -1) break;
        }

        const focusButton = (buttonId) => {
          setFocusedButton(buttonId);
          if (buttonId === "rooftop" && rooftopRef.current)
            rooftopRef.current.focus();
          else if (buttonId === "clubLevel" && clubLevelRef.current)
            clubLevelRef.current.focus();
          else if (buttonId === "vipCastle" && vipCastleRef.current)
            vipCastleRef.current.focus();
          else if (buttonId === "vipBoat" && vipBoatRef.current)
            vipBoatRef.current.focus();
          else if (buttonId === "exit" && exitRef.current)
            exitRef.current.focus();
        };

        const move = (dir) => {
          let newRow = currentRow;
          let newCol = currentCol;

          switch (dir) {
            case "right":
              newCol++;
              if (
                newCol >= gridButtons[newRow].length ||
                gridButtons[newRow][newCol] === null
              ) {
                newRow = (newRow + 1) % gridButtons.length;
                newCol = 0;
              }
              break;
            case "left":
              newCol--;
              if (newCol < 0) {
                newRow = (newRow - 1 + gridButtons.length) % gridButtons.length;
                newCol = gridButtons[newRow].length - 1;
              }
              break;
            case "down":
              newRow = (newRow + 1) % gridButtons.length;
              break;
            case "up":
              newRow = (newRow - 1 + gridButtons.length) % gridButtons.length;
              break;
            default:
              break;
          }

          newCol = Math.min(newCol, gridButtons[newRow].length - 1);
          while (gridButtons[newRow][newCol] === null && newCol > 0) newCol--;
          const nextButton = gridButtons[newRow][newCol];
          if (nextButton) focusButton(nextButton);
        };

        switch (e.key) {
          case "ArrowRight":
            e.preventDefault();
            move("right");
            break;
          case "ArrowLeft":
            e.preventDefault();
            move("left");
            break;
          case "ArrowDown":
            e.preventDefault();
            move("down");
            break;
          case "ArrowUp":
            e.preventDefault();
            move("up");
            break;
          case "Enter":
            e.preventDefault();
            if (focusedButton === "rooftop") handleRooftopClick();
            else if (focusedButton === "clubLevel") handleHotelSuiteClick();
            else if (focusedButton === "vipCastle") handleVipCastleClick();
            else if (focusedButton === "vipBoat") handleVipBoatClick();
            else if (focusedButton === "exit") handleExitClick();
            break;
          default:
            break;
        }
      };

      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    }
  }, [isTv, focusedButton]);

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundImage: `url(/static/vip/door-2/${
          isTv ? "tv-bg.png" : "display-bg2.jpg"
        })`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px",
      }}
    >
      {isTv ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "40px",
            maxWidth: "1600px",
            width: "100%",
            marginTop: "90px",
          }}
        >
          {/* Top Row */}
          <div
            style={{
              display: "flex",
              gap: "40px",
              justifyContent: "center",
            }}
          >
            {/* Rooftop */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <div
                ref={rooftopRef}
                onClick={handleRooftopClick}
                onFocus={() => setFocusedButton("rooftop")}
                onBlur={() => setFocusedButton(null)}
                tabIndex={0}
                style={getCardStyle("rooftop")}
              >
                <img
                  src="/static/vip/door-2/roof.jpg"
                  alt="VIP Rooftop Terrace"
                  style={{
                    width: "103%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div style={getLabelStyle()}>VIP Rooftop Terrace (MK)</div>
            </div>

            {/* Club Level */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <div
                ref={clubLevelRef}
                onClick={handleHotelSuiteClick}
                onFocus={() => setFocusedButton("clubLevel")}
                onBlur={() => setFocusedButton(null)}
                tabIndex={0}
                style={getCardStyle("clubLevel")}
              >
                <img
                  src="/static/vip/door-2/hotel.jpg"
                  alt="Club Level Suite"
                  style={{
                    width: "102%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div style={getLabelStyle()}>Club Level Suite (MK)</div>
            </div>

            {/* Boat */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <div
                ref={vipBoatRef}
                onClick={handleVipBoatClick}
                onFocus={() => setFocusedButton("vipBoat")}
                onBlur={() => setFocusedButton(null)}
                tabIndex={0}
                style={getCardStyle("vipBoat")}
              >
                <img
                  src="/static/vip/door-2/boat.jpg"
                  alt="VIP Fireworks Cruise"
                  style={{
                    width: "103%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div style={getLabelStyle()}>VIP Fireworks Cruise (MK)</div>
            </div>
          </div>

          {/* Bottom Row - Centered */}
          <div
            style={{
              display: "flex",
              gap: "40px",
              justifyContent: "center",
            }}
          >
            {/* Castle */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <div
                ref={vipCastleRef}
                onClick={handleVipCastleClick}
                onFocus={() => setFocusedButton("vipCastle")}
                onBlur={() => setFocusedButton(null)}
                tabIndex={0}
                style={getCardStyle("vipCastle")}
              >
                <img
                  src="/static/vip/door-2/castle.jpg"
                  alt="Castle Dinner View"
                  style={{
                    width: "103%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div style={getLabelStyle()}>Castle Dinner View (MK)</div>
            </div>

            {/* Exit */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <div
                ref={exitRef}
                onClick={handleExitClick}
                onFocus={() => setFocusedButton("exit")}
                onBlur={() => setFocusedButton(null)}
                tabIndex={0}
                style={getCardStyle("exit", true)}
              >
                <span
                  style={{
                    color: "white",
                    fontSize: "58px",
                    fontWeight: "bold",
                    fontFamily: "lato",
                    letterSpacing: "3px",
                  }}
                >
                  EXIT
                </span>
              </div>
              <div style={getLabelStyle()}></div>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          {/* Rooftop (Top Left) */}
          <div
            ref={rooftopRef}
            onClick={handleRooftopClick}
            style={{
              position: "absolute",
              top: "23%",
              left: "2.5%",
              width: "28%",
              height: "26%",
            }}
          />

          {/* Club Level (Top Center) */}
          <div
            ref={clubLevelRef}
            onClick={handleHotelSuiteClick}
            style={{
              position: "absolute",
              top: "23%",
              left: "36%",
              width: "28%",
              height: "26%",
            }}
          />

          {/* Boat (Top Right) */}
          <div
            ref={vipBoatRef}
            onClick={handleVipBoatClick}
            style={{
              position: "absolute",
              top: "23%",
              left: "69.5%",
              width: "28%",
              height: "26%",
            }}
          />

          {/* Castle (Bottom Left) */}
          <div
            ref={vipCastleRef}
            onClick={handleVipCastleClick}
            style={{
              position: "absolute",
              top: "62.5%",
              left: "19%",
              width: "28%",
              height: "26%",
            }}
          />

          {/* Exit (Bottom Right) */}
          <div
            ref={exitRef}
            onClick={handleExitClick}
            style={{
              position: "absolute",
              top: "62.5%",
              left: "55%",
              width: "28%",
              height: "26%",
            }}
          />
        </div>
      )}

      <VipSubCheck />
    </div>
  );
};

export default VipSelectorDoor2;
